module.exports = __webpack_public_path__ + "img/12.3e40aff5.png";